import styled from '@emotion/styled';
import { Button, Typography } from '@mgmresorts/mgm-ui';

export const StyledModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const StyledModal = styled.div<{ maxWidth?: string }>`
  background: ${({ theme }) => theme.semantic.BgDefault};
  border-radius: ${({ theme }) => theme.semantic.BorderRadiusComponentXl}px;
  width: 380px;
  max-width: calc(100vw - 32px);
  height: auto;
  min-height: 273px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
  position: relative;
  margin: 16px;

  @media (max-width: 480px) {
    width: calc(100vw - 32px);
    margin: 16px;
  }
`;

export const StyledCloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: ${({ theme }) => theme.core.FontsizeXl}px;
  color: ${({ theme }) => theme.semantic.FgSubtle};
  flex: none;
  order: 1;
  flex-grow: 0;
  z-index: 1;

  &:hover {
    color: ${({ theme }) => theme.semantic.FgDefault};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const StyledModalContent = styled.div<{ showCloseButton?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${({ theme }) => theme.semantic.SpaceLayoutS}px;
  gap: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  margin: 0 auto;
`;

export const StyledModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px ${({ theme }) => theme.semantic.SpaceLayoutS}px 0px 0px;
  gap: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  width: 100%;
  max-width: 332px;
  min-height: 27px;
  position: relative;

  @media (max-width: 480px) {
    padding: 0px 8px 0px 0px;
  }
`;

export const StyledModalTitle = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  margin: 0;
  flex: 1;
  text-align: left;
`;

export const StyledMessageSection = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.semantic.SpaceComponentXs}px;
  width: 100%;
  max-width: 332px;
`;

export const StyledModalMessage = styled(Typography)`
  width: 100%;
  max-width: 332px;
  color: ${({ theme }) => theme.semantic.FgDefault};
  word-wrap: break-word;
  line-height: 1.5;
`;

export const StyledModalBody = styled.div`
  width: 100%;
  max-width: 332px;
  font-weight: 400;
  font-size: ${({ theme }) => theme.core.FontsizeM}px;
  color: ${({ theme }) => theme.semantic.FgDefault};
  word-wrap: break-word;
  line-height: 1.5;
`;

export const StyledModalActions = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.semantic.SpaceComponentS}px;
  width: 100%;
  max-width: 332px;
  min-height: 56px;
  justify-content: flex-end;

  @media (max-width: 390px) {
    gap: ${({ theme }) => theme.semantic.SpaceComponentXs}px;
  }
`;

export const StyledSecondaryButton = styled(Button)`
  justify-content: center;
  align-items: center;
  min-width: 100px;
  height: 56px;
  flex-shrink: 1;
  font-size: ${({ theme }) => theme.core.FontsizeM}px !important;

  & > span,
  & * {
    font-size: ${({ theme }) => theme.core.FontsizeM}px !important;
  }

  @media (max-width: 390px) {
    min-width: 80px;
  }
`;

export const StyledPrimaryButton = styled(Button)`
  justify-content: center;
  align-items: center;
  min-width: 100px;
  height: 56px;
  flex-shrink: 1;
  font-size: ${({ theme }) => theme.core.FontsizeM}px !important;

  & > span,
  & * {
    font-size: ${({ theme }) => theme.core.FontsizeM}px !important;
  }

  @media (max-width: 390px) {
    min-width: 80px;
  }
`;
